import { Component, OnInit, Optional, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { Router, CanActivate } from '@angular/router';
import { AuthService } from '../app-services/auth.service';
import { FormsModule } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { UserService } from '../app-services/user.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';


@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

    emailErrors;
    passwordErrors;

    constructor(
        private authService: AuthService,
        private userService: UserService,
        private router: Router,
        @Optional() public dialogRef: MatDialogRef<LoginComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    ngOnInit() {

    }


    public onSubmit(value: any) {

        this.emailErrors = '';
        this.passwordErrors = '';

        this.authService.login(value).subscribe(res => {
            // nothing to do here!
            this.authService.setTokenAndForward(res, true);
            this.userService.getUserCurrency();
            this.router.navigate(['/networth']);

        },
        error => {
            if (error.status === 403) {
                this.emailErrors = 'This email/password combination does not exist';
            } else if (error.status === 422) {
                if (error.json().error.errors.email) {
                    this.emailErrors = error.json().error.errors.email[0];
                }
                if (error.json().error.errors.password) {
                    this.passwordErrors = error.json().error.errors.password[0];
                }
            }
        });
    }

}







// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/mmam/angular/src/app/login/login.component.ts